import { createClient } from '@/shared/api';
import UPDATE_RMA_TICKET_MUTATION from '../mutations/updateRmaTicket';

/**
 * Applies an update to an existing RMA ticket. Runs UPDATE_RMA_TICKET_MUTATION and returns the updateRmaTicket payload directly, without inspecting a success flag.
 *
 * @param input - Mutation input payload.
 * @returns The updateRmaTicket mutation payload.
 */
const handleUpdateRmaTicket = async (input: any) => {
  const client = createClient();
  const result = await client.mutate({
    mutation: UPDATE_RMA_TICKET_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { updateRmaTicket } = data;
  return updateRmaTicket;
};

export default handleUpdateRmaTicket;
